module.exports = __webpack_public_path__ + "images/external_images/img/100x100/img2.jpg";